import { Injectable, Inject } from '@angular/core';

export class PolicyPremiumBreakupDO {
    public id: Number = null;
    public discountPrct: Number = 0.0;
    public discount: Number = 0.0;
    public commissionPrct: Number = 0.0;
    public commission: Number = 0.0;
    public adminCharges: Number = 0.0;
    public stampDuty: Number = 0.0;
    public totalBasePremium: Number = 0.0;
    public totalExtraPremium: Number = 0.0;
    public totalPremium: Number = 0.0;


}
